import React from 'react';
import { Alert } from '@raisin/components-lib';

export const InternalErrorDisplay = (props: { message: string }) => (
  <Alert mode="error">{props.message}</Alert>
);
